import './about.css';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faChevronRight,
  faShieldAlt,
  faUserShield,
  faKey,
  faEraser,
  faFileExport,
  faBan,
  faBalanceScale,
  faFileAlt,
  faEnvelope
} from "@fortawesome/free-solid-svg-icons";


const GDPR = () => {
  const currentDate = new Intl.DateTimeFormat('ro-RO', {
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  }).format(new Date());

  return (
  
      <div className="general-container-footer-info-ab">
                 <div className="info-footer-container-ab">
           
      


                     <div className='tittle-ab-top'>
                        <h4>Protectia Datelor Personale (GDPR)</h4>
                    </div>
           
                   
           
                {/* Introducere GDPR */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faShieldAlt} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Ce este GDPR?</h4>
    <p>
      Regulamentul General privind Protectia Datelor (GDPR - General Data Protection Regulation) este o legislatie europeana 
      care protejeaza drepturile si libertatile persoanelor in ceea ce priveste prelucrarea datelor cu caracter personal.
    </p>
    <p>
      La ContaLearn, respectam pe deplin prevederile GDPR si ne angajam sa protejam datele tale personale cu cea mai mare grija.
    </p>
    <p><strong>Data aplicarii:</strong> {currentDate}</p>
  </div>
</section>

{/* Drepturile tale conform GDPR */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Drepturile tale conform GDPR</h4>
    <p>
      In conformitate cu GDPR, ai urmatoarele drepturi fundamentale:
    </p>
    <ul style={{marginTop: '15px', listStyleType: 'none', paddingLeft: 0}}>
      <li style={{marginBottom: '10px'}}>
        <strong>🔍 Dreptul de acces (Art. 15 GDPR)</strong> — Poti solicita informatii despre datele personale pe care le procesam despre tine
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>✏️ Dreptul de rectificare (Art. 16 GDPR)</strong> — Poti cere corectarea datelor inexacte sau completarea datelor incomplete
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>🗑️ Dreptul la stergerea datelor (Art. 17 GDPR)</strong> — "Dreptul de a fi uitat" - poti solicita stergerea datelor tale
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>⏸️ Dreptul la restrictionarea prelucrarii (Art. 18 GDPR)</strong> — Poti limita modul in care folosim datele tale
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>📦 Dreptul la portabilitatea datelor (Art. 20 GDPR)</strong> — Poti primi datele tale intr-un format structurat si portabil
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>🚫 Dreptul de opozitie (Art. 21 GDPR)</strong> — Te poti opune prelucrarii datelor tale in anumite conditii
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>🤖 Dreptul de a nu fi supus deciziilor automate (Art. 22 GDPR)</strong> — Protectie impotriva profilarii automate
      </li>
    </ul>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faUserShield} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Dreptul de acces */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faKey} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Dreptul de acces la date (Art. 15 GDPR)</h4>
    <p>
      Ai dreptul sa obtii de la ContaLearn o confirmare ca prelucram sau nu date cu caracter personal care te privesc 
      si, in caz afirmativ, acces la acestea.
    </p>
    <p><strong>Ce poti solicita:</strong></p>
    <ul style={{listStyleType: 'none', paddingLeft: 0}}>
      <li>▸ O copie a datelor personale</li>
      <li>▸ Scopurile prelucrarii</li>
      <li>▸ Categoriile de date prelucrate</li>
      <li>▸ Destinatarii datelor tale</li>
      <li>▸ Perioada de stocare a datelor</li>
      <li>▸ Existenta drepturilor GDPR</li>
    </ul>
    <p><strong>Termen de raspuns:</strong> Maximum 30 zile de la solicitare</p>
  </div>
</section>

{/* Dreptul la stergere */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Dreptul la stergerea datelor - "Dreptul de a fi uitat" (Art. 17 GDPR)</h4>
    <p>
      Poti solicita stergerea datelor tale personale in urmatoarele situatii:
    </p>
    <ul style={{listStyleType: 'none', paddingLeft: 0}}>
      <li>✓ Datele nu mai sunt necesare pentru scopurile pentru care au fost colectate</li>
      <li>✓ Iti retragi consimtamantul si nu exista alt temei legal pentru prelucrare</li>
      <li>✓ Te opui prelucrarii si nu exista motive legitime care sa prevaleze</li>
      <li>✓ Datele au fost prelucrate ilegal</li>
      <li>✓ Datele trebuie sterse pentru respectarea unei obligatii legale</li>
    </ul>
    <p><strong>Exceptii:</strong> Nu putem sterge datele daca prelucrarea este necesara pentru:</p>
    <ul style={{listStyleType: 'none', paddingLeft: 0}}>
      <li>▸ Respectarea unei obligatii legale</li>
      <li>▸ Constatarea, exercitarea sau apararea unui drept in instanta</li>
      <li>▸ Motive de interes public in domeniul sanatatii publice</li>
    </ul>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faEraser} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Dreptul la portabilitate */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faFileExport} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Dreptul la portabilitatea datelor (Art. 20 GDPR)</h4>
    <p>
      Ai dreptul sa primesti datele personale pe care ni le-ai furnizat intr-un format structurat, utilizat in mod curent 
      si care poate fi citit automat (de exemplu: JSON, CSV, XML).
    </p>
    <p><strong>Ce include:</strong></p>
    <ul style={{listStyleType: 'none', paddingLeft: 0}}>
      <li>▸ Datele pe care le-ai furnizat direct (nume, email, etc.)</li>
      <li>▸ Datele generate prin utilizarea platformei (progres, raspunsuri, rezultate)</li>
    </ul>
    <p>
      De asemenea, poti solicita transmiterea directa a acestor date catre alt operator, unde este posibil din punct de vedere tehnic.
    </p>
  </div>
</section>

{/* Dreptul de opozitie */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Dreptul de opozitie (Art. 21 GDPR)</h4>
    <p>
      Te poti opune oricand, din motive legate de situatia ta particulara, ca datele tale sa fie prelucrate pe baza:
    </p>
    <ul>
      <li>▸ Interesului legitim al ContaLearn (Art. 6(1)(f) GDPR)</li>
      <li>▸ Interesului public (Art. 6(1)(e) GDPR)</li>
    </ul>
    <p><strong>Marketing direct:</strong></p>
    <p>
      Te poti opozi oricand si neconditionat prelucrarii datelor tale in scopuri de marketing direct. 
      In acest caz, vom inceta imediat prelucrarea pentru aceste scopuri.
    </p>
    <p><strong>Cum te poti opune:</strong></p>
    <ul>
      <li>▸ Prin setarile contului tau</li>
      <li>▸ Prin click pe "Dezabonare" din email-urile noastre</li>
      <li>▸ Prin solicitare la suport@contalearn.ro</li>
    </ul>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faBan} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Baze legale */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faBalanceScale} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Bazele legale ale prelucrarii (Art. 6 GDPR)</h4>
    <p>
      Prelucram datele tale personale numai pe baze legale conforme GDPR:
    </p>
    <ul style={{marginTop: '15px', listStyleType: 'none', paddingLeft: 0}}>
      <li style={{marginBottom: '10px'}}>
        <strong>Art. 6(1)(a) - Consimtamant</strong><br />
        Ai dat consimtamantul pentru prelucrarea datelor (ex: newsletter, marketing)
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>Art. 6(1)(b) - Executarea contractului</strong><br />
        Prelucrarea este necesara pentru executarea contractului (ex: furnizarea cursurilor)
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>Art. 6(1)(c) - Obligatie legala</strong><br />
        Prelucrarea este necesara pentru respectarea unei obligatii legale (ex: evidenta contabila)
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>Art. 6(1)(f) - Interes legitim</strong><br />
        Prelucrarea este necesara pentru un interes legitim (ex: prevenirea fraudelor, imbunatatirea platformei)
      </li>
    </ul>
  </div>
</section>

{/* Cum exerciti drepturile */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Cum iti exerciti drepturile GDPR?</h4>
    <p>
      Pentru a-ti exercita oricare dintre drepturile enumerate mai sus, ne poti contacta prin:
    </p>
    <div style={{background: '#f0f9f8', padding: '20px', borderRadius: '10px', marginTop: '15px', border: '2px solid #13b8ab'}}>
      <p style={{margin: '5px 0'}}><strong>📧 Email:</strong> suport@contalearn.ro</p>
      <p style={{margin: '5px 0'}}><strong>📝 Subiect:</strong> "Solicitare GDPR - [tipul dreptului]"</p>
    </div>
    <p style={{marginTop: '15px'}}><strong>Ce trebuie sa incluzi in solicitare:</strong></p>
    <ul style={{listStyleType: 'none', paddingLeft: 0}}>
      <li>▸ Numele complet</li>
      <li>▸ Adresa de email asociata contului</li>
      <li>▸ Descrierea clara a dreptului pe care vrei sa-l exerciti</li>
      <li>▸ Documentul de identitate (pentru verificarea identitatii)</li>
    </ul>
    <p style={{marginTop: '15px'}}>
      <strong>Termen de raspuns:</strong> Vom raspunde solicitarii tale in maximum <strong>30 zile</strong> de la primire. 
      In cazuri complexe, putem prelungi termenul cu inca 60 zile, informandu-te in acest sens.
    </p>
    <p style={{marginTop: '10px'}}>
      <strong>Costuri:</strong> De regula, exercitarea drepturilor este <strong>gratuita</strong>. 
      In cazuri exceptionale (solicitari manifesta nefondate sau excesive), ne rezervam dreptul de a percepe o taxa rezonabila.
    </p>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faFileAlt} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Plangeri */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faBalanceScale} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Dreptul de a depune plangere</h4>
    <p>
      Daca consideri ca drepturile tale GDPR au fost incalcate, ai dreptul sa depui o plangere la autoritatea de supraveghere:
    </p>
    <div style={{background: '#f0f9f8', padding: '20px', borderRadius: '10px', marginTop: '15px', border: '2px solid #13b8ab'}}>
      <h4 style={{margin: '0 0 10px 0', color: '#13b8ab'}}>🇷🇴 Autoritatea Nationala de Supraveghere a Prelucrarii Datelor cu Caracter Personal (ANSPDCP)</h4>
      <p style={{margin: '5px 0'}}><strong>📍 Adresa:</strong> B-dul G-ral. Gheorghe Magheru 28-30, Sector 1, Bucuresti</p>
      <p style={{margin: '5px 0'}}><strong>📞 Telefon:</strong> +40 318 059 211 / +40 318 059 212</p>
      <p style={{margin: '5px 0'}}><strong>📧 Email:</strong> anspdcp@dataprotection.ro</p>
      <p style={{margin: '5px 0'}}><strong>🌐 Website:</strong> <a href='https://www.dataprotection.ro/' target='_blank' rel='noopener noreferrer'>www.dataprotection.ro</a></p>
    </div>
    <p style={{marginTop: '15px'}}>
      Cu toate acestea, te incurajam sa ne contactezi mai intai la <strong>suport@contalearn.ro</strong> pentru a incerca sa rezolvam situatia direct.
    </p>
  </div>
</section>

{/* Contact */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Contact pentru GDPR</h4>
    <p>
      Pentru orice intrebari legate de protectia datelor personale sau exercitarea drepturilor GDPR, contacteaza-ne:
    </p>
    <div style={{background: '#f0f9f8', padding: '20px', borderRadius: '10px', marginTop: '15px', border: '2px solid #13b8ab'}}>
      <p style={{margin: '5px 0'}}><strong>📩 Email:</strong> suport@contalearn.ro</p>
      <p style={{margin: '5px 0'}}><strong>📝 Subiect:</strong> "GDPR - Protectia Datelor"</p>
    </div>
    <p style={{marginTop: '15px'}}>
      Suntem aici pentru a proteja datele tale si pentru a-ti respecta toate drepturile conform legislatiei GDPR.
    </p>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faEnvelope} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

           
            <div className='line-about'></div>
           
                 
           
                 </div>
               </div>
   
  );
};

export default GDPR;

